export default __webpack_public_path__ + "static/media/Taiwo.147b4257.jpg";